import White from './White'

export default White
